<div class="flex h-full flex-col divide-y divide-gray-200">
  <!-- Aggregated IQ ticket stats: cases opened in range -->
  <div class="flex flex-1 flex-col">
    <div class="flex flex-col bg-white px-4 pb-4">
      <h3 class="py-2 text-start text-base font-medium">
        Aggregated Ticket Stats
      </h3>
      <p class="-mt-1 text-xs">Cases opened (IQ-related)</p>
      @if (isLoading()) {
        <div
          class="mt-2 flex w-full flex-col items-center justify-center gap-2"
          role="status"
          aria-label="Loading ticket stats"
        >
          <div class="w-full animate-pulse space-y-2">
            <div class="mx-auto h-8 w-24 rounded bg-gray-200"></div>
          </div>
          <span class="sr-only">Loading ticket stats…</span>
        </div>
      } @else {
        <span
          class="mt-1 block w-full text-center text-3xl font-semibold tabular-nums"
        >
          {{ metrics()?.count ?? 0 | number }}
        </span>
      }
    </div>
  </div>

  <!-- Mean Time to Repair -->
  <div class="flex flex-1 flex-col">
    <div class="flex flex-col bg-white px-4 pb-4">
      <h3 class="py-2 text-start text-base font-medium">Mean Time to Repair</h3>
      @if (isLoading()) {
        <div
          class="mt-2 flex w-full flex-col items-center justify-center gap-2"
          role="status"
          aria-label="Loading mean time to repair"
        >
          <div class="w-full animate-pulse space-y-2">
            <div class="mx-auto h-8 w-32 rounded bg-gray-200"></div>
          </div>
          <span class="sr-only">Loading mean time to repair…</span>
        </div>
      } @else {
        <span
          class="mt-1 block w-full text-center text-3xl font-semibold tabular-nums"
        >
          {{ formattedMttr() }}
        </span>
      }
    </div>
  </div>
</div>
